<quill-editor class="text-box__editor"
              [ngClass]="{'text-box__editor--readonly': readOnly}"
              [(ngModel)]="localText"
              [modules]="quillModules"
              [readOnly]="readOnly"
              (onContentChanged)="textChange($event)">
</quill-editor>
